export type Selection = StrictRecord<number, true>;

export interface NestedOutputFilter {
  outputName: string;
  outputLabel: string;
  namesAndLabels: AnswerOptionFilter[];
}

export interface AnswerOptionFilter {
  name: string;
  label: string;
  filterOut: boolean;
}

export class FusionState {
  frameNumber = 0;
  nestedOutputFilter: StrictRecord<string, NestedOutputFilter> = {};
  shapeListPanelExpanded: ShapeListPanelExpanded = {
    shapes: {},
    groups: {},
  };
  isRightPanelExpanded = false;

  // This is used for the temporary, hacky subpoint-tags feature. See
  // subpoint-binding.service.ts for details.
  syncSubpointShapes = false;
}

export interface ShapeListPanelExpanded {
  shapes: StrictRecord<string, boolean>;
  groups: StrictRecord<string, boolean>;
}
